import { render, staticRenderFns } from "./DragAndDropMultipleLists.vue?vue&type=template&id=0bc82157&"
import script from "./DragAndDropMultipleLists.vue?vue&type=script&lang=js&"
export * from "./DragAndDropMultipleLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports